var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center"},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":15,"width":1,"indeterminate":""}}):(!_vm.isAdminUser && _vm.isHasSameClinic)?_c('v-icon',{class:_vm.iconColor,attrs:{"size":"24","disabled":_vm.mergeItemLoading},on:{"click":_vm.toggleUser}},[_vm._v(_vm._s('mdi-merge'))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }